import React from 'react';

import AppLayout from '../../components/AppLayout';

import AccountingRegulation from './components/AccountingRegulation';
import BookingApiKeys from './components/BookingApiKeys';
import BookingSystem from './components/BookingSystem';
import DatevAccountNumber from './components/DatevAccountNumber';
import UserInfo from './components/UserInfo';

const MySettingsPage: React.FC = () => {
  return (
    <AppLayout>
      <div className='p-6'>
        <div className='max-w-4xl mx-auto'>
          <h1 className='text-3xl font-bold mb-6 text-gray-900 dark:text-white'>
            Account Settings
          </h1>

          <div className='space-y-6'>
            <UserInfo />
            <AccountingRegulation />
            <BookingSystem />
            <BookingApiKeys />
            <DatevAccountNumber />
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default MySettingsPage;
